import React, { useState, useEffect } from 'react';
import { 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Button, 
  Input, 
  Label, 
  FormGroup
} from 'reactstrap';

const EditTeeChoiceModal = ({ isOpen, toggle, onSave, item }) => {
  const [teeData, setTeeData] = useState({
    prompt: '',
    tee: '',
    sort: 0
  });

  useEffect(() => {
    if (item) {
      setTeeData({
        prompt: item.prompt || '',
        tee: item.tee || '',
        sort: item.sort || 0
      });
    }
  }, [item, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTeeData(prev => ({
      ...prev,
      [name]: name === 'sort' ? parseInt(value) || 0 : value
    }));
  };

  const handleSave = () => {
    if (!teeData.prompt.trim() || !teeData.tee.trim()) {
      alert('Please fill in all required fields');
      return;
    }
    onSave(teeData);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Tee Choice</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="prompt">Prompt *</Label>
          <Input
            type="text"
            id="prompt"
            name="prompt"
            value={teeData.prompt}
            onChange={handleChange}
            placeholder="e.g., Red Tees"
          />
          <small className="text-muted">Label shown to players during registration</small>
        </FormGroup>
        <FormGroup>
          <Label for="tee">Tee Value *</Label>
          <Input
            type="text"
            id="tee"
            name="tee"
            value={teeData.tee}
            onChange={handleChange}
            placeholder="e.g., Red, Blue, White, Gold"
          />
          <small className="text-muted">Value stored when player selects this option</small>
        </FormGroup>
        <FormGroup>
          <Label for="sort">Sort Order</Label>
          <Input
            type="number"
            id="sort"
            name="sort"
            value={teeData.sort}
            onChange={handleChange}
            placeholder="0"
          />
          <small className="text-muted">Lower numbers display first (0 = first)</small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave}>
          Update Tee Choice
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditTeeChoiceModal;
